import { LEGACY_MENTORSHIP_ENABLED } from "src/shared/constants/featureFlags";
import { BaseRoute, Route } from "src/shared/constants/route";

export const getSuggestedRoutes = (
  legacyMentorshipEnabled = LEGACY_MENTORSHIP_ENABLED
) =>
  Object.values(Route).filter(
    (route) =>
      route !== Route.NOT_FOUND &&
      (legacyMentorshipEnabled ||
        (route !== Route.HACKER_MENTORSHIP &&
          !route.startsWith(`${BaseRoute.MENTOR}/`)))
  );
